import { render, staticRenderFns } from "./addComplaintTypeList.vue?vue&type=template&id=2c8d597e&scoped=true"
import script from "./addComplaintTypeList.vue?vue&type=script&lang=js"
export * from "./addComplaintTypeList.vue?vue&type=script&lang=js"
import style0 from "./addComplaintTypeList.vue?vue&type=style&index=0&id=2c8d597e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d597e",
  null
  
)

export default component.exports